
import React, { useEffect } from 'react';
import { trackHit } from '../services/wordpress';

const HitTracker: React.FC = () => {
  useEffect(() => {
    // Delay sedikit agar tidak mengganggu loading konten utama
    const timer = setTimeout(() => {
      trackHit();
    }, 2000);
    
    return () => clearTimeout(timer);
  }, []);

  return null; // Tidak me-render apapun di UI publik
};

export default HitTracker;
